import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hi, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Accidents as a result of playing a sport professionally.',
          'Accidents that occur following the use of recreational drugs or medicines, whether obtained fraudulently or not prescribed by a competent medical authority.',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          '€{0} per day if you are admitted to hospital following an accident, from the first night up to 50 days.',
          '€5,000 to your beneficiaries in the event of your death following an accident.',
          'Protection extended to your employees.',
        ],
        title: 'This coverage includes',
      },
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Accident coverage',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Les retards consécutifs aux conditions météorologiques ;',
          'Les retards de moins d’une heure ;',
          'Les voyages réglé avec une carte autre que celle émise par Shine.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          'Une prise en charge de {0}€ par heure pour tout retard de train, avion ou bateau de plus d’une heure dans la limite de 1 000 € par an ;',
          'Les indemnités sont cumulables si le retard est subi sur le trajet aller et retour ;',
          'Le titre de transport ou billet doit avoir été réglé avec la carte Shine.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Retard de transport',
  },
} as const);

export default locales;
